import Stack from '@mui/material/Stack';
import { Chip } from './Chip';
import Box from '@mui/material/Box';
import useMeasure from 'react-use-measure';
import IconButton from '@mui/material/IconButton';
import MoreHorizOutlinedIcon from '@mui/icons-material/MoreHorizOutlined';
import { useTheme } from '@mui/material/styles';
import { pxToRem } from 'src/common/utils/fonts';

export type ChipsClipperProps = {
  labels: string[];
  hasMore?: boolean;
};

export const ChipsClipper = ({ labels, hasMore = false }: ChipsClipperProps) => {
  const [root, rootBounds] = useMeasure();
  const [chipsBox, chipsBoxBounds] = useMeasure();

  const diffWidth = rootBounds.width - chipsBoxBounds.width;

  const contentNotFit = diffWidth <= 0;
  const displayMoreButton = contentNotFit || hasMore;

  const { palette } = useTheme();
  return (
    <Stack width={'100%'} direction="row" ref={root} gap={4}>
      <Box
        sx={{
          overflow: 'hidden',
          maskImage: 'linear-gradient(90deg, #fff 80%, transparent)',
        }}
      >
        <Stack direction="row" ref={chipsBox} width={'max-content'} gap={4}>
          {labels.map((label) => (
            <Chip label={label} key={label} variant="outlined" />
          ))}
        </Stack>
      </Box>
      {displayMoreButton ? (
        <Box>
          <IconButton
            size="small"
            sx={{ width: pxToRem(18), height: pxToRem(24), p: 0, pointerEvents: 'none' }}
          >
            <MoreHorizOutlinedIcon
              style={{ marginBottom: -20, width: pxToRem(18), color: palette.text.tertiary }}
            />
          </IconButton>
        </Box>
      ) : null}
    </Stack>
  );
};
